import { render, staticRenderFns } from "./PowerRealData.vue?vue&type=template&id=704502a6&scoped=true"
import script from "./PowerRealData.vue?vue&type=script&lang=js"
export * from "./PowerRealData.vue?vue&type=script&lang=js"
import style0 from "./PowerRealData.vue?vue&type=style&index=0&id=704502a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704502a6",
  null
  
)

export default component.exports